import { datadogLogs } from '@datadog/browser-logs';
import axios from 'axios';
import { showToast } from 'components/Toast';
import { ENV_CONFIG } from 'config/environment';
import API_ROUTES from 'services/apiRoutes';
import { getAccessToken } from 'services/storage';
import { Dispatch } from 'redux';
import PAYOUTS_TYPES, { IPayoutsData } from './types';

const headers = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  'X-Auth-Version': 'v2',
};

export const getPayouts =
  (recipient_id: string, active_role: string) =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(PAYOUTS_TYPES.payoutsStart());

    const MAX_PAGES = 100;
    const baseUrl = `${ENV_CONFIG().API.BASE_URL}${API_ROUTES.GET_PAYOUTS(recipient_id)}`;
    const allReports: IPayoutsData[] = [];
    let cursor: string | null = null;
    let pages = 0;
    try {
      do {
        const response = await axios.get(baseUrl, {
          headers: { ...headers, Authorization: `Bearer ${getAccessToken()}` },
          params: { active_role, ...(cursor ? { cursor } : {}) },
        });
        allReports.push(...(response.data.payout_reports || []));
        cursor = response.data.next_cursor || null;
        pages += 1;
        if (pages >= MAX_PAGES) {
          datadogLogs.logger.info('Payout reports pagination exceeded MAX_PAGES limit', {});
          break;
        }
      } while (cursor);

      dispatch(PAYOUTS_TYPES.payoutsSuccess(allReports));
    } catch (error: any) {
      datadogLogs.logger.info('Error fetching payout reports for recipient', {}, error);
      if (allReports.length > 0) {
        showToast('Some reports could not be loaded.', 'error', error?.response?.status);
        dispatch(PAYOUTS_TYPES.payoutsSuccess(allReports));
      } else {
        showToast(error.message, 'error', error?.response?.status);
        dispatch(PAYOUTS_TYPES.payoutsError(error.message));
      }
    }
  };
